<template>
    <div>
        <div class="tab-links">
            <div v-for="tab in tabs" :key="tab.name" :class="tabClass(tab.name)" @click="tabClick(tab)">
                {{ tab.displayName }}
            </div>
        </div>
        <slot></slot>
    </div>
</template>

<script>
    export default {
        props: {
            tabs: { type: Array, required: true, validator: (arr) => !!arr && arr.length },
            selectedTab: { type: Object, default: undefined },
        },

        computed: {
            activeTab() {
                return this.selectedTab || this.tabs[0]
            },
        },

        methods: {
            tabClass(name) {
                return {
                    'tab-links__tab': true,
                    'tab-links__tab--active': this.activeTab.name === name,
                }
            },

            tabClick(tab) {
                this.emitEvent({ name: 'tab-click', payload: tab })
            },
        },
    }
</script>
